module.exports = __webpack_public_path__ + "static/media/Еня.cbccf5d3.jpg";